import Vue from 'vue'
import Vuex from 'vuex'
import LocalState from './plugin/LocalState'
import sev from './modules/sev'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    sev
  },
  plugins: [LocalState],
  state: {
    appToken: ''
  },
  mutations: {
    SET_APPTOKEN(state, token) {
      state.appToken = token
    },
    // 重置用户信息
    RESET(state) {
      state.appToken = ''
    }
  }
})
